/* enso-trust-drawers.js — PDP trust row opens side drawers (23 Sep 2026). Product template only.

   Everything a shopper sees is server-rendered; this file is deliberately small.
   - Captions: <button class="epc__tcap" data-epc-open="epcm-trust-…"> printed by
     snippets/epc-icon.liquid inside the section's .epc__trust cells.
   - Drawers #epcm-trust-g / -r / -d: snippets/epc-trust-drawers.liquid, rendered by
     epc-icon.liquid inside the returns cell (which also loads this file), so they arrive
     inside .epc__buy.
   - Open, close, Escape, focus return and scroll lock: the section's own
     [data-epc-open] / [data-epc-close] handler on #epc, shared with the tear sheet.

   This file only:
   1. moves the drawers from .epc__buy (a z-index:2 stacking context, which would trap a
      fixed panel under the header) up to #epc;
   2. makes the phone-only "Free delivery £40+" cell (appended by enso-pdp-roomfirst.js)
      and the "Delivery details" link open the delivery drawer;
   3. on open, puts the live total on the drawer's Add to bag (hidden if the real button
      is disabled) and copies the arrival dates into the delivery drawer;
   4. records which drawer was opened: dataLayer {event:'trust_open', trust_item} and a
      Clarity event trust_open_<item>. Which doubt people check is the useful signal. */
(function () {
  if (window.__ensoTrust) return;
  window.__ensoTrust = 1;

  var IDS = { 'epcm-trust-g': 'guarantee', 'epcm-trust-r': 'returns', 'epcm-trust-d': 'delivery' };

  function txt(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }

  function lift(root) {
    for (var id in IDS) {
      var dw = document.getElementById(id);
      if (dw && dw.parentNode !== root) root.appendChild(dw);
    }
  }

  /* returns true once the phone delivery cell has been turned into a button */
  function wireDelivery(root) {
    if (!document.getElementById('epcm-trust-d')) return true;

    // "Delivery details" under the arrival estimate. On phones roomfirst moves this same
    // <a> into its Delivery row as "Details"; the attribute travels with it.
    var a = root.querySelector('.epc__eta a') || root.querySelector('.epc__rflist a[href*="/pages/delivery"]');
    if (a && !a.hasAttribute('data-epc-open')) {
      a.setAttribute('data-epc-open', 'epcm-trust-d');
      a.setAttribute('aria-haspopup', 'dialog');
    }

    var cells = root.querySelectorAll('.epc__trust > div');
    for (var i = 0; i < cells.length; i++) {
      var cell = cells[i];
      if (cell.querySelector('.epc__tcap')) continue;
      var s = cell.querySelector('span');
      if (!s || !/deliver/i.test(txt(s))) continue;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'epc__tcap';
      b.setAttribute('data-epc-open', 'epcm-trust-d');
      b.setAttribute('aria-haspopup', 'dialog');
      b.textContent = txt(s);
      cell.replaceChild(b, s);
      return true;
    }
    return false;
  }

  function prime(id) {
    var dw = document.getElementById(id);
    if (!dw) return;
    var cta = document.querySelector('#epc .epc__cta');
    var foot = dw.querySelector('.epc__dwfoot');
    if (foot) foot.hidden = !cta || cta.disabled;
    var add = dw.querySelector('.epc__tadd');
    var total = txt(document.getElementById('epcTotal'));
    if (add && total) add.textContent = 'Add to bag · ' + total;
    if (id === 'epcm-trust-d') {
      var when = txt(document.querySelector('#epc .epc__eta p b'));
      var p = dw.querySelector('.epc__teta');
      if (p && when) {
        p.querySelector('b').textContent = when.replace(/\s+to\s+/, ' – ');
        p.hidden = false;
      }
    }
  }

  function track(item) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'trust_open', trust_item: item });
    } catch (e) {}
    try { if (typeof window.clarity === 'function') window.clarity('event', 'trust_open_' + item); } catch (e) {}
  }

  /* Runs after the section's handler on #epc has opened the drawer (document is later in
     the bubble path), so it only decorates and records. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var opener = t.closest('[data-epc-open^="epcm-trust-"]');
    if (opener) {
      var id = opener.getAttribute('data-epc-open');
      prime(id);
      if (IDS[id]) track(IDS[id]);
      return;
    }
    var add = t.closest('.epc__tadd');
    if (add) {
      e.preventDefault();
      var dw = add.closest('.epc__dw');
      var x = dw && dw.querySelector('.epc__dwclose');
      if (x) x.click();
      var cta = document.querySelector('#epc .epc__cta');
      if (cta && !cta.disabled) cta.click();
    }
  });

  function init() {
    var root = document.getElementById('epc');
    if (!root) return;
    lift(root);
    if (wireDelivery(root)) return;
    if (!window.matchMedia('(max-width: 749px)').matches) return; // the third cell is phone-only
    var n = 0;
    var timer = setInterval(function () {
      n++;
      if (wireDelivery(root) || n > 20) clearInterval(timer);
    }, 150);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
